import React from 'react';

const VideoComponent = ({ src = '' }) => (
  <div className="w-full mobile:mb-6 xs:mb-8">
    <video src={src} alt="Video" className="flex h-auto w-full" controls />
  </div>
);

export default VideoComponent;
